import { render, staticRenderFns } from "./JobContent.vue?vue&type=template&id=42a03afa&scoped=true"
import script from "./JobContent.vue?vue&type=script&lang=js"
export * from "./JobContent.vue?vue&type=script&lang=js"
import style0 from "./JobContent.vue?vue&type=style&index=0&id=42a03afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a03afa",
  null
  
)

export default component.exports